<template>
  <div>
    <template v-if="!url">
      {{ this.item }}
    </template>
    <template v-else>
      <router-link :to="url" class="border-b border-transparent hover:border-orange-brand">
        {{ item.title }}
      </router-link>
    </template>
  </div>
</template>

<script>
export default {
  name: 'BaseCreditsItem',
  props: {
    item: [Object, String]
  },
  computed: {
    url () {
      if (typeof this.item === 'string') return false
      return this.localeLink(this.item.slug)
    }
  }
}
</script>
